import { Heading } from "theme-ui";
import * as React from 'react';
export default {
  Heading,
  React
};